import styled from "styled-components"

export const Star = styled.span`
  font-size: 1.5rem;
  margin-right: 1rem;
  color: ${(props) => (props.active ? "gold" : "black")};
`

export const ReviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 0 2rem 0;
`

export const StarsContainer = styled.div`
  display: flex;
`
